<script setup lang="ts">
import { AccordionHeader, AccordionHeaderProps } from "primevue";

defineProps<AccordionHeaderProps>();
</script>

<template>
  <AccordionHeader
    :pt="
      $props.pt ?? {
        root: {
          class: '!p-0',
        },
      }
    "
    v-bind="$attrs"
  >
    <slot />
  </AccordionHeader>
</template>
